var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI04Element(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0366 3.77597H24.0874C24.9693 3.77602 25.2596 3.95179 25.3521 4.03867C25.4248 4.1071 25.5991 4.33234 25.5991 5.12558V13.6256C25.5991 14.4188 25.4248 14.6441 25.3521 14.7125C25.2596 14.7994 24.9693 14.9751 24.0874 14.9752H19.0366C18.1548 14.9751 17.8644 14.7994 17.772 14.7125C17.6992 14.6441 17.5249 14.4188 17.5249 13.6256V5.12558C17.5249 4.33234 17.6992 4.1071 17.772 4.03867C17.8644 3.95179 18.1548 3.77602 19.0366 3.77597Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 2.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91162 15.026H10.9624C11.8443 15.026 12.1346 15.2018 12.2271 15.2887C12.2998 15.3571 12.4741 15.5823 12.4741 16.3756V24.8756C12.4741 25.6688 12.2998 25.8941 12.2271 25.9625C12.1346 26.0494 11.8443 26.2251 10.9624 26.2252H5.91162C5.02976 26.2251 4.73945 26.0494 4.64697 25.9625C4.57423 25.8941 4.3999 25.6688 4.3999 24.8756V16.3756C4.3999 15.5823 4.57423 15.3571 4.64697 15.2887C4.73945 15.2018 5.02976 15.026 5.91162 15.026Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 2.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0366 20.0254H24.0874C24.9693 20.0254 25.2596 20.2012 25.3521 20.2881C25.4248 20.3565 25.5991 20.5817 25.5991 21.375V24.875C25.5991 25.6682 25.4248 25.8934 25.3521 25.9619C25.2596 26.0488 24.9693 26.2245 24.0874 26.2246H19.0366C18.1548 26.2245 17.8644 26.0488 17.772 25.9619C17.6992 25.8934 17.5249 25.6682 17.5249 24.875V21.375C17.5249 20.5817 17.6992 20.3565 17.772 20.2881C17.8644 20.2012 18.1548 20.0254 19.0366 20.0254Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 2.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91162 3.77597H10.9624C11.8443 3.77602 12.1346 3.95179 12.2271 4.03867C12.2998 4.1071 12.4741 4.33234 12.4741 5.12558V8.62558C12.4741 9.41882 12.2998 9.64406 12.2271 9.71249C12.1346 9.79937 11.8443 9.97514 10.9624 9.97519H5.91162C5.02976 9.97514 4.73945 9.79937 4.64697 9.71249C4.57423 9.64406 4.3999 9.41882 4.3999 8.62558V5.12558C4.3999 4.33234 4.57423 4.1071 4.64697 4.03867C4.73945 3.95179 5.02976 3.77602 5.91162 3.77597Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 2.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI04Element);
export default __webpack_public_path__ + "static/media/I04-element.a501d4f107fa870084552ac7644060fa.svg";
export { ForwardRef as ReactComponent };